import {useSignal} from "@preact/signals-react";
import {useCallback, useEffect} from "react";
import {isEmpty} from "@ui-seeker/utils";

import {productsMatcherImageComparatorModalData} from "../@signals";


export default function useImageComparisonNavigation(brandOptions=[], setSelectedSKU) {
	const numOptions = brandOptions?.length
	const isOpen = !isEmpty(productsMatcherImageComparatorModalData.value)

	const localIndex = useSignal(
		Number.isInteger(productsMatcherImageComparatorModalData.value?.targetIndex)
			? productsMatcherImageComparatorModalData.value?.targetIndex
			: 0
	)

	const handleChangeModalData = idx => {
		const option = brandOptions[idx]
		if (option) {
			setSelectedSKU(option.productID)
			const candidateName = `${option.superTitle || ''} ${option.productTitle} ${option.subtitle || ''} ${option.variant || ''}`.trim()
			productsMatcherImageComparatorModalData.value = {
				...productsMatcherImageComparatorModalData.value,
				targetIndex: idx,
				title: `${option.superTitle} ${option.productTitle} ${option.subtitle}`,
				urlRight: option.thumbnail,
				candidateName: candidateName,
			}
		}
	}

	useEffect(() => {
		if (!isOpen)
			return

		const idx = Number.isInteger(productsMatcherImageComparatorModalData.value?.targetIndex)
			? productsMatcherImageComparatorModalData.value?.targetIndex
			: 0

		localIndex.value = idx;
		handleChangeModalData(idx)
	}, [isOpen, productsMatcherImageComparatorModalData.value?.targetIndex]);

	const handleNavigate = useCallback((delta) => {
		if (!numOptions)
			return

		const max = numOptions - 1
		const next = Math.min(Math.max((localIndex.value ?? 0) + delta, 0), max)
		if (next === localIndex.value)
			return
		handleChangeModalData(next)
	}, [numOptions])

	return {
		isOpen,
		numOptions,
		localIndex: localIndex.value,

		handleNavigate,
		handleNavigateLeft: () => handleNavigate(-1),
		handleNavigateRight: () => handleNavigate(1),
	}
}